export default __webpack_public_path__ + "static/media/yash.8b66ea31.jpeg";